import React from 'react';
import styled from '@emotion/styled';
import { UploadImage } from '../../../../assets';

export interface AttributeValues {
  backgroundImage?: string;
  textColor?: string;
  title?: string;
  ctaText?: string;
  describeText?: string;
  describeText2?: string;
}
interface PreviewProps {
  values: AttributeValues & any;
  isPreview?: boolean;
  height?: string;
  className?: string;
}

export const PreviewCartnerConvos = (props: PreviewProps) => {
  const { values, isPreview, height, className } = props;
  const { backgroundImage, describeText } = values;
  const isDefaultImage = backgroundImage === '' || !backgroundImage || !isPreview;

  return (
    <StyledCartnerConvosPreview className={className} style={{ height: height || '400px' }}>
      <div>
        <div className="preview-ant-image">
          {!isDefaultImage ? (
            <img className="image-cartner-convos" src={backgroundImage} alt="" />
          ) : (
            <div className="image-default">
              <img src={UploadImage} alt="" />
              <div className="describeText">{describeText}</div>
            </div>
          )}
        </div>
      </div>
    </StyledCartnerConvosPreview>
  );
};

const StyledCartnerConvosPreview = styled.div`
  margin: 1.5rem 0 0 1.4rem;
  min-height: 380px;
  border-radius: 16px;
  width: 86%;
  & .heading {
    margin-top: 16px;
    font-weight: 800;
    font-size: 17px;
    padding: 0 1rem;
  }
  & .image-border {
    border-bottom: 1px #c3c3c3 solid;
  }
  & .preview-ant-image {
    width: 100%;
    cursor: pointer;
    & .image-cartner-convos {
      margin-top: -10px;
      width: 100%;
      max-height: 400px;
      object-fit: cover;
      padding: 0;
      border-radius: 18px;
    }
    & .image-default {
      justify-content: center;
      text-align: center;
      & img {
        margin-top: 8rem;
        width: 6rem;
        height: 6rem;
      }
      & .describeText {
        font-size: 14px;
        padding-top: 1rem;
        font-weight: 700;
      }
    }
  }
  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logo-brand {
    margin: 0.7rem 1rem;
    & .logo-tm {
      width: 2.5rem;
      padding-right: 10px;
      height: auto;
    }
    & .img-partner {
      padding-left: 10px;
      width: auto;
      max-height: 3rem;
    }
  }
  .uploadText {
    position: absolute;
    width: 100%;
    text-align: center;
    margin-top: 4rem;
    color: white;
  }
  .textContainer {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .wrapper-text-preview {
    position: absolute;
    bottom: 20%;
    width: 100%;
    padding: 0 1rem;
  }
  & .title {
    font-size: 25px;
  }
  & .priceColor {
    display: block;
    font-size: 11px;
  }
  .promotion-preview {
    & .description {
      font-size: 25px;
    }
    & .title {
      font-size: 14px;
    }
  }
  & .wrapper-btn-preview {
    position: absolute;
    bottom: 8px;
    width: 100%;
    display: flex;
    padding: 0 1rem;
    & .button {
      border-radius: 1rem;
      background: #fff;
      color: #000;
      height: 30px;
      font-size: 16px;
      padding: 0.2rem 1.25rem 0 1.25rem;
    }
  }
  .logo-brand {
    margin: 0.5rem;
    & .logo-tm {
      width: auto;
      max-height: 1rem;
      padding-right: 5px;
    }
    & .img-logo {
      width: auto;
      max-height: 1rem;
      padding-right: 3px;
      border-right: 1px solid #666666;
    }
  }
  & .tag-css {
    font-size: 12px;
    padding: 2px 0 0 3px;
    text-transform: uppercase;
    color: #666666;
    font-weight: 500;
  }
  @media screen and (max-width: 1440px) {
    .text-preview {
      bottom: 13%;
    }
    & .description {
      font-size: 12px;
    }
    & .title {
      font-size: 21px;
    }

    .promotion-preview {
      & .description {
        font-size: 21px;
      }
      & .title {
        font-size: 15px;
      }
    }
  }
`;
